import { HtmlEditor, HtmlEditorTools } from '@yes.technology/react-toolkit'
import { ActivityValue, StatusClass } from 'types/shared'

type ActivityInputRichTextProps = {
  id: string
  statusClass: StatusClass
  informational?: boolean
  required?: boolean
  value: string
  onChange: (value: ActivityValue) => void
  label: string
  disabled?: boolean
  tools?: HtmlEditorTools
  placeholder?: string
}

function ActivityInputRichText({
  id,
  statusClass,
  informational,
  required,
  value,
  onChange,
  label,
  disabled,
  tools,
  placeholder
}: ActivityInputRichTextProps) {
  return (
    <HtmlEditor
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      required={required}
      informational={informational}
      statusClass={statusClass}
      heightClass='regular'
      disabled={disabled}
      toolbarTools={tools}
      placeholder={placeholder}
    />
  )
}

export default ActivityInputRichText
